import { ThemeProvider } from '@mui/material/styles';
import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';

import GlobalStyle from '@/styles/globals';
import theme from '@/styles/theme';
import { AppStateProvider } from '@/utils/AppState';
import { initDatadog } from '@/utils/Datadog';

const LDProvider = dynamic(() => import('@/components/LDProvider/LDProvider'), {
  ssr: false,
});

initDatadog();

const MyApp = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <AppStateProvider>
          <LDProvider>
            <GlobalStyle altBackground={pageProps.altBackground} />
            <Component {...pageProps} />
          </LDProvider>
        </AppStateProvider>
      </ThemeProvider>
    </>
  );
};

export default MyApp;
